<template>
    <div class="group-news app">
        <swiperBanner :bannerList='bannerList'></swiperBanner>
        <div class="main-content">
           <div class="tab-box clearfix hand-shape">
               <div class="tab" :class="{active:status==index}"  @click="getSwitchList(index)" v-for="(tab,index) in switchTab" :key="index">{{tab.name}}<span class="tab-line bg-blue"></span></div>
           </div>
           <div class="tab-content-box">
                <div class="tab-content clearfix hand-shape" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)">
                    <div class="img-left fl">
                        <img :src="item.img" alt="" class="img-responsive">
                    </div>
                    <div class="img-right fr">
                        <div class="pt10 title txt_limit">{{item.title}}</div>
                        <div class="pt20 describe txt_limit2">{{item.description}}</div>
                        <div class="pt20 more"><span>{{formatTime.getMsecToSpecificTime(item.addtime,'yyyy年MM月dd日 hh:mm:ss')}}</span>
                            <span class="color-blue fr">查看全部<img src="../../assets/images/arrow-right.png" alt="" class="arrow-icon"></span>
                        </div>
                    </div>
                </div>
           </div>
           <el-col  :span="24" class="toolbar">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="alltotal">
                </el-pagination>
                <nav-top></nav-top>
            </el-col>
        </div>
    </div>
</template>
<script>
import swiperBanner from '@/components/swiperBanner'
import navTop from '@/components/top'
import seoArgs from '../../utils/setSeoArgs';

export default {
    components: {
        swiperBanner,
        navTop
    },
    data() {
        return {
            page: 1,//重新获取的当前的页码
            alltotal:0,//总的数据
            pageSize:10,//每一条的页数是10
            bannerList:[],
            dataList:[],
            switchTab: [], 
            status:this.$route.params.collegeId || 0
        };
    },
    created() {
        this.getBanner();
        this.getTab();
    },
    mounted() {

    },
    watch: {
        $route( to , from ){
            this.status=to.params.collegeId;
            if(this.switchTab.length>0){
                //document.title=this.switchTab[this.status].name;
                seoArgs.setSeoArgs(this.switchTab[this.status]);
                this.getList(this);
            }
        }
    },
    methods: {
        getBanner(){
            this.$axios.post(this.api.index.banners,{item:'TcCollege'},res =>{
                this.bannerList=res.data;
                if(this.bannerList.length==0){
                    this.bannerList=[{img: "../../static/banner.png"}];
                }
            },err =>{
                this.bannerList=[];
            });
        },
        goDetail:function(id){
            this.$router.push('/tcCollegeDetail/'+ this.status +'/'+id+'/'+this.switchTab[this.status].name+'.html');
        },
        getSwitchList(index) {
            this.status=index;
            if(this.switchTab.length>0){
                //document.title=this.switchTab[this.status].name;
                seoArgs.setSeoArgs(this.switchTab[this.status]);
                this.getList(this);
            } 
        },
        getTab(){
            this.$axios.post(this.api.tcCollege.classList,{},res =>{
                this.switchTab=res.data;
                if(this.switchTab.length>0){
                    //document.title=this.switchTab[this.status].name;
                    seoArgs.setSeoArgs(this.switchTab[this.status]);
                    this.getList(this);
                }
                
            },err =>{
                this.switchTab=[]
            });
        },
        getList(obj) {
            //tab切换
            obj.$axios.post(obj.api.tcCollege.list,{
                class:obj.switchTab[obj.status].id,
                page:obj.page,
                page_size:obj.pageSize
            },res =>{
                obj.dataList=res.data;
                obj.alltotal=Number(res.pageInfo.totalCount);
            },err =>{
                obj.dataList=[];
            });
        },
        //页面改变
        handleCurrentChange(val) {
            this.page=val;
            this.getList(this);
        },
        //每页的页数改变
        handleSizeChange(val) {
            this.pageSize=val;
            this.getList(this);
        },
    }
};
</script>
<style scoped>
/* tab列表信息展示 */
.tab-content-box{padding-top:20px;}
.tab-content{margin-bottom:20px;height:220px;padding:20px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(13,52,130,0.1);border-radius:5px;}
.tab-content:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
.tab-content .img-left{width:240px;height:180px;margin-right:20px;}
.tab-content .img-right{width:900px;}
.tab-content .img-right .title{font-size:18px;color:rgba(51,51,51,1);line-height:25px;}
.tab-content .img-right .describe{font-size:14px;color:rgba(102,102,102,1);line-height:20px;}
.tab-content .img-right .more{color:rgba(153,153,153,1);line-height:20px;}
</style>


// WEBPACK FOOTER //
// src/view/college/index.vue